import { render } from "./SyncProviderComponent.vue?vue&type=template&id=52f434ef"
import script from "./SyncProviderComponent.vue?vue&type=script&lang=js"
export * from "./SyncProviderComponent.vue?vue&type=script&lang=js"

import "./SyncProviderComponent.vue?vue&type=style&index=0&id=52f434ef&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__